<template>
	<div class="app-wrapper">
		<div class="aIbtn" @click="aiClick()"></div>
		<div class="app-container">
			<el-scrollbar class="sidebar-container">
				<div class="menu-container">
					<!-- <router-link to="/claims"> -->
						<div class="menu-wrapper pointer" @click="gotoPage('/claims')">
							<div class="menu-item">
								<img class="menu-icon" :src="require('@/icons/svg/menu1.svg')" />
							</div>
							<p>诉讼业务工作台</p>
						</div>
					<!-- </router-link> -->
					<!-- <router-link to="/no-claims"> -->
						<div class="menu-wrapper pointer" @click="gotoPage('/no-claims')">
							<div class="menu-item menu2">
								<img class="menu-icon" :src="require('@/icons/svg/menu2.svg')" />
							</div>
							<p>非诉讼业务工作台</p>
						</div>
					<!-- </router-link> -->
					<!-- <router-link to="/knowledgeBase"> -->
						<div class="menu-wrapper pointer" @click="gotoPage('/knowledgeBase')">
							<div class="menu-item menu3">
								<img class="menu-icon" :src="require('@/icons/svg/menu3.svg')" />
							</div>
							<p>知识库</p>
						</div>
					<!-- </router-link> -->
					<!-- <router-link to="/orther"> -->
						<div class="menu-wrapper pointer" @click="gotoPage('/orther')">
							<div class="menu-item menu4">
								<img class="menu-icon" :src="require('@/icons/svg/menu4.svg')" />
							</div>
							<p>其他事务</p>
						</div>
					<!-- </router-link> -->
					<!-- <router-link to="/client"> -->
						<div class="menu-wrapper pointer" @click="gotoPage('/client')">
							<div class="menu-item menu5">
								<img class="menu-icon" :src="require('@/icons/svg/menu5.svg')" />
							</div>
							<p>我负责的客户</p>
						</div>
					<!-- </router-link> -->
					<div class="menu-wrapper pointer" @click="gotoPage('/ai-chat')" v-if="showAi">
						<div class="menu-item menu6">
							<img class="menu-icon" :src="require('@/icons/svg/msg.svg')" />
						</div>
						<p>AI助手</p>
					</div>
				</div>
			</el-scrollbar>
		</div>
	</div>
</template>

<script>
import { getConfigKey } from '@/api/index.js'
	export default {
		name: 'LeftMenu',
		computed: {
			fixedHeader() {
				return this.$store.state.settings.fixedHeader
			},
		},
		data() {
			return {
				menuList: [],
				showAi: false,
				// 隐藏AI相关
				clickCount: 0, // 点击计数器
				lastClickTime: 0 // 上次点击时间
			}
		},
		mounted() {
			//获取AI显示参数
		    getConfigKey('Aishow').then(res => {
				if(res.data){
					res.data=='1'?this.showAi = true:this.showAi =false;
				}
			})
		},
		methods: {
			aiClick() {
				const now = Date.now()
				// 如果距离上次点击超过3秒，重置计数
				if (now - this.lastClickTime > 3000) {
					this.clickCount = 0
				}
				this.lastClickTime = now
				this.clickCount++

				if (this.clickCount >= 5) {
					this.clickCount = 0
					this.$router.push({
						path: '/ai-chat'
					})
				}
				
			},
			//跳转
			gotoPage(str) {
				if(this.$route.path == str){
					location.reload()
				}
				this.$router.push({
					path: str
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "~@/styles/mixin.scss";
	@import "~@/styles/variables.scss";

	.sidebar-container {
		height: 100% !important;
	}

	.app-wrapper {
		position: relative;
		height: calc(100vh - 130px) !important;
		width: 100%;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		.aIbtn{
			position: absolute;
			bottom: 20px;
			left: 50%;
			transform: translateX(-50%);
			width: 200px;
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: center;
			z-index: 9999 !important;
		}
	}

	.app-container {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: row;
	}

	.menu-container {
		display: flex;
		flex-wrap: wrap;
	}

	.menu-wrapper {
		width: 140px;
		height: 150px;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-left: 30px;
		margin-top: 20px;
	}

	.menu-item {
		width: 100px;
		height: 130px;
		position: relative;
		background: linear-gradient(to bottom, #3e6cb1, #32569e);
		box-shadow: 0 1px 4px rgba(0, 21, 41, .1);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border-radius: 30px;

		.menu-icon {
			width: 68px;
			height: 68px;
			z-index: 100;
		}
	}

	.menu2 {
		background: linear-gradient(to bottom, #555cb2, #36428e);
	}

	.menu3 {
		background: linear-gradient(to bottom, #5fbc6c, #3f9463);
	}

	.menu4 {
		background: linear-gradient(to bottom, #5d7587, #546776);
	}

	.menu5 {
		background: linear-gradient(to bottom, #377c93, #206283);
	}

	.menu6 {
		background: linear-gradient(to bottom, #84624f, #4b6f78);
	}
</style>
